import { useSyncExternalStore } from 'react';

// Lets a page give its own breadcrumb a readable title instead of the raw URL segment.
let current = { path: null, title: null };
const listeners = new Set();

export const setBreadcrumbTitle = (path, title) => {
  current = { path, title };
  listeners.forEach(listener => listener());
};

export const clearBreadcrumbTitle = (path) => {
  if (current.path === path) setBreadcrumbTitle(null, null);
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useBreadcrumbTitle = () => useSyncExternalStore(subscribe, () => current);
